.EntityWatermark {
  font-size: 100px;
}

// All icons have the same size but only the footprint of the database fills the very bottom
.EntityWatermarkDatabase {
  font-size: 90px;
}

.EntityWatermarkPlaceholder {
  width: 100px;
}

.EntityWatermarkDatabasePlaceholder {
  width: 90px;
}
